import { Card } from '@mui/material';
import Editor from '@/components/tiptap/Editor';

export default function TextItem({ item }) {
  return (
    <Card sx={{ flex: 1, minWidth: 0, px: 3, py: 2 }}>
      <Editor content={item.content || ""} editable={false} />
    </Card>
  );
}
